// epos.js
import React, { useEffect, useState } from "react";

const Epos = ({ userData }) => {
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState("");

  useEffect(() => {
    // Load branches from localStorage (same source used elsewhere in your app)
    const stored = JSON.parse(localStorage.getItem("members") || "[]");
    setBranches(stored);
    if (stored.length > 0) {
      setSelectedBranchId(stored[0].pharmacyId);
    }
  }, []);

  const handlePlaceholder = (label) => {
    alert(`${label} — coming soon`);
  };

  return (
    <div style={{ padding: "16px" }}>
      <h2 style={{ marginTop: 0 }}>EPOS</h2>

      {/* Branch selector */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px", flexWrap: "wrap" }}>
        <label htmlFor="epos-branch" style={{ fontWeight: 600 }}>Select branch</label>
        <select
          id="epos-branch"
          value={selectedBranchId}
          onChange={(e) => setSelectedBranchId(e.target.value)}
          style={{ padding: "6px", borderRadius: "4px", border: "1px solid #ccc", minWidth: "260px" }}
        >
          {branches.length === 0 && <option value="">No branches found</option>}
          {branches.map((b) => (
            <option key={b.pharmacyId} value={b.pharmacyId}>
              {b.pharmacyName || b.pharmacyId}
            </option>
          ))}
        </select>
      </div>

      {/* Action buttons (placeholders) */}
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
        <button onClick={() => handlePlaceholder("Current stock")} >
          Current stock
        </button>
        <button onClick={() => handlePlaceholder("Pictorial view")} >
          Pictorial view
        </button>
        <button onClick={() => handlePlaceholder("Stock changes")} >
          Stock changes
        </button>
        <button onClick={() => handlePlaceholder("Financial analysis")} >
          Financial analysis
        </button>
        <button onClick={() => handlePlaceholder("Export display to xls")} >
          Export display to xls
        </button>
      </div>

      {/* Info box (optional context) */}
      <div style={{ marginTop: "8px", padding: "12px", border: "1px solid #e5e7eb", borderRadius: "8px", background: "#fafafa" }}>
        <div><strong>Selected branch ID:</strong> {selectedBranchId || "-"}</div>
        {userData && (
          <div style={{ marginTop: "6px" }}>
            <strong>User:</strong> {userData.name || userData.email || "Signed-in user"}
          </div>
        )}
        <p style={{ marginTop: "10px", color: "#555" }}>
          All actions above are placeholders. Hook them up to your EPOS endpoints and render results here.
        </p>
      </div>
    </div>
  );
};

export default Epos;
